/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_StatementInputs */

const en_landing_statement = /** @type {(inputs: Landing_StatementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-conviction research should not die in an inbox, and the commission it earns should not go to someone else.`)
};

/**
* | output |
* | --- |
* | "High-conviction research should not die in an inbox, and the commission it earns should not go to someone else." |
*
* @param {Landing_StatementInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_statement = /** @type {((inputs?: Landing_StatementInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_StatementInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_statement(inputs)
});